// extracted by mini-css-extract-plugin
export var dividerLine = "_58-0";
export var errorBackground = "_58-1";